@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(802_603_240)
public val Res.string.timeline_intro_mine: StringResource by lazy {
      StringResource("string:timeline_intro_mine", "timeline_intro_mine", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 357981, 223),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 509821, 391),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 329008, 223),
      ))
    }

@delegate:ResourceContentHash(-583_989_109)
public val Res.string.timeline_intro_team: StringResource by lazy {
      StringResource("string:timeline_intro_team", "timeline_intro_team", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 358205, 367),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 510213, 619),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 329232, 323),
      ))
    }

@delegate:ResourceContentHash(-811_018_599)
public val Res.string.timeline_kind_contract: StringResource by lazy {
      StringResource("string:timeline_kind_contract", "timeline_kind_contract", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 358573, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 510833, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 329556, 42),
      ))
    }

@delegate:ResourceContentHash(669_551_863)
public val Res.string.timeline_kind_employment: StringResource by lazy {
      StringResource("string:timeline_kind_employment", "timeline_kind_employment", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 358612, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 510884, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 329599, 48),
      ))
    }

@delegate:ResourceContentHash(-1_939_660_226)
public val Res.string.timeline_kind_end: StringResource by lazy {
      StringResource("string:timeline_kind_end", "timeline_kind_end", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 358661, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 510961, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 329648, 49),
      ))
    }

@delegate:ResourceContentHash(2_147_238_411)
public val Res.string.timeline_kind_hire: StringResource by lazy {
      StringResource("string:timeline_kind_hire", "timeline_kind_hire", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 358723, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 511039, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 329698, 34),
      ))
    }

@delegate:ResourceContentHash(311_387_190)
public val Res.string.timeline_kind_medical: StringResource by lazy {
      StringResource("string:timeline_kind_medical", "timeline_kind_medical", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 358786, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 511110, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 329733, 45),
      ))
    }

@delegate:ResourceContentHash(-115_646_205)
public val Res.string.timeline_kind_not_counted: StringResource by lazy {
      StringResource("string:timeline_kind_not_counted", "timeline_kind_not_counted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 358840, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 511176, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 329779, 81),
      ))
    }

@delegate:ResourceContentHash(1_475_957_103)
public val Res.string.timeline_kind_note: StringResource by lazy {
      StringResource("string:timeline_kind_note", "timeline_kind_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 358922, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 511318, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 329861, 34),
      ))
    }

@delegate:ResourceContentHash(1_115_232_263)
public val Res.string.timeline_kind_ohs: StringResource by lazy {
      StringResource("string:timeline_kind_ohs", "timeline_kind_ohs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 358961, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 511365, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 329896, 41),
      ))
    }

@delegate:ResourceContentHash(-1_399_376_729)
public val Res.string.timeline_kind_pay: StringResource by lazy {
      StringResource("string:timeline_kind_pay", "timeline_kind_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 359007, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 511467, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 329938, 29),
      ))
    }

@delegate:ResourceContentHash(-997_279_018)
public val Res.string.timeline_kind_student: StringResource by lazy {
      StringResource("string:timeline_kind_student", "timeline_kind_student", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 359053, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 511509, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 329968, 49),
      ))
    }

@delegate:ResourceContentHash(284_126_126)
public val Res.string.timeline_kind_tax_relief: StringResource by lazy {
      StringResource("string:timeline_kind_tax_relief", "timeline_kind_tax_relief", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 359103, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 511579, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 330018, 48),
      ))
    }

@delegate:ResourceContentHash(1_871_389_171)
public val Res.string.timeline_kind_unpaid: StringResource by lazy {
      StringResource("string:timeline_kind_unpaid", "timeline_kind_unpaid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 359156, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 511656, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 330067, 44),
      ))
    }

@delegate:ResourceContentHash(13_015_120)
public val Res.string.timeline_lane_absences: StringResource by lazy {
      StringResource("string:timeline_lane_absences", "timeline_lane_absences", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 359209, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 511713, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 330112, 42),
      ))
    }

@delegate:ResourceContentHash(972_330_191)
public val Res.string.timeline_lane_labour: StringResource by lazy {
      StringResource("string:timeline_lane_labour", "timeline_lane_labour", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 359260, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 511776, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 330155, 56),
      ))
    }

@delegate:ResourceContentHash(646_146_219)
public val Res.string.timeline_lane_overtime: StringResource by lazy {
      StringResource("string:timeline_lane_overtime", "timeline_lane_overtime", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 359313, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 511865, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 330212, 42),
      ))
    }

@delegate:ResourceContentHash(2_120_751_051)
public val Res.string.timeline_lane_remote_events: StringResource by lazy {
      StringResource("string:timeline_lane_remote_events", "timeline_lane_remote_events", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 359360, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 511948, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 330255, 67),
      ))
    }

@delegate:ResourceContentHash(1_790_527_173)
public val Res.string.timeline_mine: StringResource by lazy {
      StringResource("string:timeline_mine", "timeline_mine", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 359432, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 512048, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 330323, 37),
      ))
    }

@delegate:ResourceContentHash(-758_220_935)
public val Res.string.timeline_moving_to: StringResource by lazy {
      StringResource("string:timeline_moving_to", "timeline_moving_to", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 359474, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 512106, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 330361, 46),
      ))
    }

@delegate:ResourceContentHash(1_549_048_463)
public val Res.string.timeline_no_pay_terms: StringResource by lazy {
      StringResource("string:timeline_no_pay_terms", "timeline_no_pay_terms", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 359525, 177),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 512173, 301),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 330408, 161),
      ))
    }

@delegate:ResourceContentHash(340_598_548)
public val Res.string.timeline_not_available: StringResource by lazy {
      StringResource("string:timeline_not_available", "timeline_not_available", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 359703, 90),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 512475, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 330570, 82),
      ))
    }

@delegate:ResourceContentHash(-1_454_415_111)
public val Res.string.timeline_not_counted_hint: StringResource by lazy {
      StringResource("string:timeline_not_counted_hint", "timeline_not_counted_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 359794, 201),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 512582, 301),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 330653, 193),
      ))
    }

@delegate:ResourceContentHash(657_447_636)
public val Res.string.timeline_open: StringResource by lazy {
      StringResource("string:timeline_open", "timeline_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 359996, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 512884, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 330847, 45),
      ))
    }

@delegate:ResourceContentHash(1_804_166_390)
public val Res.string.timeline_pay_hourly: StringResource by lazy {
      StringResource("string:timeline_pay_hourly", "timeline_pay_hourly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 360042, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 512958, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 330893, 43),
      ))
    }

@delegate:ResourceContentHash(-526_002_184)
public val Res.string.timeline_pay_monthly: StringResource by lazy {
      StringResource("string:timeline_pay_monthly", "timeline_pay_monthly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 360094, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 513030, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 330937, 48),
      ))
    }

@delegate:ResourceContentHash(-1_717_578_332)
public val Res.string.timeline_pay_salary_fte: StringResource by lazy {
      StringResource("string:timeline_pay_salary_fte", "timeline_pay_salary_fte", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 360147, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 513095, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 330986, 67),
      ))
    }

@delegate:ResourceContentHash(115_205_093)
public val Res.string.timeline_problem_contract_after_end: StringResource by lazy {
      StringResource("string:timeline_problem_contract_after_end", "timeline_problem_contract_after_end", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 360215, 247),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 513179, 387),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 331054, 227),
      ))
    }

@delegate:ResourceContentHash(-1_856_111_706)
public val Res.string.timeline_problem_contract_before_hire: StringResource by lazy {
      StringResource("string:timeline_problem_contract_before_hire", "timeline_problem_contract_before_hire", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 360463, 265),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 513567, 373),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 331282, 237),
      ))
    }

@delegate:ResourceContentHash(-1_769_641_110)
public val Res.string.timeline_problem_contract_same_day: StringResource by lazy {
      StringResource("string:timeline_problem_contract_same_day", "timeline_problem_contract_same_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 360729, 154),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 513941, 214),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 331520, 166),
      ))
    }

@delegate:ResourceContentHash(-717_437_621)
public val Res.string.timeline_problem_date_missing: StringResource by lazy {
      StringResource("string:timeline_problem_date_missing", "timeline_problem_date_missing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 360884, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 514156, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 331687, 57),
      ))
    }

@delegate:ResourceContentHash(1_123_530_046)
public val Res.string.timeline_problem_end_before_hire: StringResource by lazy {
      StringResource("string:timeline_problem_end_before_hire", "timeline_problem_end_before_hire", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 360942, 200),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 514222, 256),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 331745, 156),
      ))
    }

@delegate:ResourceContentHash(1_477_042_174)
public val Res.string.timeline_problem_end_before_shift_on: StringResource by lazy {
      StringResource("string:timeline_problem_end_before_shift_on", "timeline_problem_end_before_shift_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 361143, 312),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 514479, 432),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 331902, 248),
      ))
    }

@delegate:ResourceContentHash(1_098_395_027)
public val Res.string.timeline_problem_end_before_shifts: StringResource by lazy {
      StringResource("string:timeline_problem_end_before_shifts", "timeline_problem_end_before_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 361456, 166),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 514912, 238),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 332151, 138),
      ))
    }

@delegate:ResourceContentHash(-1_208_586_607)
public val Res.string.timeline_problem_end_before_start: StringResource by lazy {
      StringResource("string:timeline_problem_end_before_start", "timeline_problem_end_before_start", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 361623, 105),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 515151, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 332290, 89),
      ))
    }

@delegate:ResourceContentHash(-1_167_314_374)
public val Res.string.timeline_problem_hire_after_shift_on: StringResource by lazy {
      StringResource("string:timeline_problem_hire_after_shift_on", "timeline_problem_hire_after_shift_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 361729, 168),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 515285, 220),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 332380, 168),
      ))
    }

@delegate:ResourceContentHash(1_727_482_580)
public val Res.string.timeline_problem_hire_after_shifts: StringResource by lazy {
      StringResource("string:timeline_problem_hire_after_shifts", "timeline_problem_hire_after_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 361898, 166),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 515506, 226),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 332549, 122),
      ))
    }

@delegate:ResourceContentHash(139_998_364)
public val Res.string.timeline_problem_hire_has_shifts: StringResource by lazy {
      StringResource("string:timeline_problem_hire_has_shifts", "timeline_problem_hire_has_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 362065, 204),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 515733, 292),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 332672, 192),
      ))
    }

@delegate:ResourceContentHash(-670_284_524)
public val Res.string.timeline_problem_no_pay_terms: StringResource by lazy {
      StringResource("string:timeline_problem_no_pay_terms", "timeline_problem_no_pay_terms", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 362270, 105),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 516026, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 332865, 97),
      ))
    }

@delegate:ResourceContentHash(790_613_279)
public val Res.string.timeline_problem_note_empty: StringResource by lazy {
      StringResource("string:timeline_problem_note_empty", "timeline_problem_note_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 362376, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 516184, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 332963, 55),
      ))
    }

@delegate:ResourceContentHash(1_825_594_427)
public val Res.string.timeline_problem_note_too_long: StringResource by lazy {
      StringResource("string:timeline_problem_note_too_long", "timeline_problem_note_too_long", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 362444, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 516260, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 333019, 90),
      ))
    }

@delegate:ResourceContentHash(1_709_794_342)
public val Res.string.timeline_problem_outside: StringResource by lazy {
      StringResource("string:timeline_problem_outside", "timeline_problem_outside", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 362539, 168),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 516403, 208),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 333110, 140),
      ))
    }

@delegate:ResourceContentHash(-986_546_728)
public val Res.string.timeline_problem_overlap: StringResource by lazy {
      StringResource("string:timeline_problem_overlap", "timeline_problem_overlap", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 362708, 200),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 516612, 304),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 333251, 200),
      ))
    }

@delegate:ResourceContentHash(571_800_654)
public val Res.string.timeline_problem_pay_after_end: StringResource by lazy {
      StringResource("string:timeline_problem_pay_after_end", "timeline_problem_pay_after_end", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 362909, 254),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 516917, 378),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 333452, 214),
      ))
    }

@delegate:ResourceContentHash(1_863_588_007)
public val Res.string.timeline_problem_pay_before_hire: StringResource by lazy {
      StringResource("string:timeline_problem_pay_before_hire", "timeline_problem_pay_before_hire", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 363164, 272),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 517296, 364),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 333667, 224),
      ))
    }

@delegate:ResourceContentHash(496_864_598)
public val Res.string.timeline_problem_pay_same_day: StringResource by lazy {
      StringResource("string:timeline_problem_pay_same_day", "timeline_problem_pay_same_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 363437, 157),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 517661, 197),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 333892, 161),
      ))
    }

@delegate:ResourceContentHash(1_166_137_385)
public val Res.string.timeline_problem_required: StringResource by lazy {
      StringResource("string:timeline_problem_required", "timeline_problem_required", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 363595, 165),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 517859, 301),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 334054, 169),
      ))
    }

@delegate:ResourceContentHash(-166_580_264)
public val Res.string.timeline_problem_too_many: StringResource by lazy {
      StringResource("string:timeline_problem_too_many", "timeline_problem_too_many", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 363761, 117),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 518161, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 334224, 105),
      ))
    }

@delegate:ResourceContentHash(-1_754_580_198)
public val Res.string.timeline_read_only: StringResource by lazy {
      StringResource("string:timeline_read_only", "timeline_read_only", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 363879, 106),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 518319, 166),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 334330, 86),
      ))
    }

@delegate:ResourceContentHash(647_741_169)
public val Res.string.timeline_relief_commuting: StringResource by lazy {
      StringResource("string:timeline_relief_commuting", "timeline_relief_commuting", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 363986, 101),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 518486, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 334417, 89),
      ))
    }

@delegate:ResourceContentHash(1_008_985_016)
public val Res.string.timeline_relief_pit2: StringResource by lazy {
      StringResource("string:timeline_relief_pit2", "timeline_relief_pit2", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 364088, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 518632, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 334507, 64),
      ))
    }

@delegate:ResourceContentHash(1_241_847_576)
public val Res.string.timeline_relief_youth: StringResource by lazy {
      StringResource("string:timeline_relief_youth", "timeline_relief_youth", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 364165, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 518733, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 334572, 61),
      ))
    }

@delegate:ResourceContentHash(1_704_073_326)
public val Res.string.timeline_remove: StringResource by lazy {
      StringResource("string:timeline_remove", "timeline_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 364724, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 519568, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 335071, 31),
      ))
    }

@delegate:ResourceContentHash(1_708_028_675)
public val Res.string.timeline_remove_hire_text: StringResource by lazy {
      StringResource("string:timeline_remove_hire_text", "timeline_remove_hire_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 364231, 221),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 518819, 337),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 334634, 177),
      ))
    }

@delegate:ResourceContentHash(470_256_406)
public val Res.string.timeline_remove_text: StringResource by lazy {
      StringResource("string:timeline_remove_text", "timeline_remove_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 364453, 216),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 519157, 332),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 334812, 204),
      ))
    }

@delegate:ResourceContentHash(34_448_245)
public val Res.string.timeline_remove_title: StringResource by lazy {
      StringResource("string:timeline_remove_title", "timeline_remove_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 364670, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 519490, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 335017, 53),
      ))
    }

@delegate:ResourceContentHash(167_365_343)
public val Res.string.timeline_request_approved: StringResource by lazy {
      StringResource("string:timeline_request_approved", "timeline_request_approved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 364756, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 519616, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 335103, 57),
      ))
    }

@delegate:ResourceContentHash(494_896_124)
public val Res.string.timeline_request_close: StringResource by lazy {
      StringResource("string:timeline_request_close", "timeline_request_close", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 364818, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 519690, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 335161, 38),
      ))
    }

@delegate:ResourceContentHash(-1_036_547_465)
public val Res.string.timeline_request_description: StringResource by lazy {
      StringResource("string:timeline_request_description", "timeline_request_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 364861, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 519741, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 335200, 68),
      ))
    }

@delegate:ResourceContentHash(-987_479_231)
public val Res.string.timeline_request_hours: StringResource by lazy {
      StringResource("string:timeline_request_hours", "timeline_request_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 364930, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 519810, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 335269, 54),
      ))
    }

@delegate:ResourceContentHash(1_038_224_767)
public val Res.string.timeline_request_no_drag: StringResource by lazy {
      StringResource("string:timeline_request_no_drag", "timeline_request_no_drag", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 364985, 228),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 519865, 312),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 335324, 180),
      ))
    }

@delegate:ResourceContentHash(1_220_393_285)
public val Res.string.timeline_request_note: StringResource by lazy {
      StringResource("string:timeline_request_note", "timeline_request_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 365214, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 520178, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 335505, 45),
      ))
    }

@delegate:ResourceContentHash(-1_702_025_024)
public val Res.string.timeline_request_place: StringResource by lazy {
      StringResource("string:timeline_request_place", "timeline_request_place", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 365260, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 520240, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 335551, 46),
      ))
    }

@delegate:ResourceContentHash(55_013_054)
public val Res.string.timeline_request_reject_text: StringResource by lazy {
      StringResource("string:timeline_request_reject_text", "timeline_request_reject_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 365311, 96),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 520295, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 335598, 100),
      ))
    }

@delegate:ResourceContentHash(1_672_857_906)
public val Res.string.timeline_request_reject_title: StringResource by lazy {
      StringResource("string:timeline_request_reject_title", "timeline_request_reject_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 365408, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 520444, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 335699, 65),
      ))
    }

@delegate:ResourceContentHash(-1_452_772_697)
public val Res.string.timeline_request_rejected: StringResource by lazy {
      StringResource("string:timeline_request_rejected", "timeline_request_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 365470, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 520522, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 335765, 57),
      ))
    }

@delegate:ResourceContentHash(1_957_055_336)
public val Res.string.timeline_request_sent: StringResource by lazy {
      StringResource("string:timeline_request_sent", "timeline_request_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 365528, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 520596, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 335823, 81),
      ))
    }

@delegate:ResourceContentHash(324_645_577)
public val Res.string.timeline_request_status: StringResource by lazy {
      StringResource("string:timeline_request_status", "timeline_request_status", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 365606, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 520722, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 335905, 47),
      ))
    }

@delegate:ResourceContentHash(809_350_610)
public val Res.string.timeline_request_title: StringResource by lazy {
      StringResource("string:timeline_request_title", "timeline_request_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 365654, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 520778, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 335953, 42),
      ))
    }

@delegate:ResourceContentHash(-1_246_001_262)
public val Res.string.timeline_request_tooltip: StringResource by lazy {
      StringResource("string:timeline_request_tooltip", "timeline_request_tooltip", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 365697, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 520825, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 335996, 60),
      ))
    }

@delegate:ResourceContentHash(-1_286_419_758)
public val Res.string.timeline_request_withdraw: StringResource by lazy {
      StringResource("string:timeline_request_withdraw", "timeline_request_withdraw", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 366072, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 521316, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 336351, 57),
      ))
    }

@delegate:ResourceContentHash(213_753_950)
public val Res.string.timeline_request_withdraw_text: StringResource by lazy {
      StringResource("string:timeline_request_withdraw_text", "timeline_request_withdraw_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 365758, 190),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 520886, 266),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 336057, 166),
      ))
    }

@delegate:ResourceContentHash(-1_580_959_203)
public val Res.string.timeline_request_withdraw_title: StringResource by lazy {
      StringResource("string:timeline_request_withdraw_title", "timeline_request_withdraw_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 365949, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 521153, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 336224, 67),
      ))
    }

@delegate:ResourceContentHash(-1_584_151_457)
public val Res.string.timeline_request_withdrawn: StringResource by lazy {
      StringResource("string:timeline_request_withdrawn", "timeline_request_withdrawn", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 366013, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 521237, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 336292, 58),
      ))
    }

@delegate:ResourceContentHash(1_093_130_298)
public val Res.string.timeline_requests_hint: StringResource by lazy {
      StringResource("string:timeline_requests_hint", "timeline_requests_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 366126, 166),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 521394, 274),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 336409, 126),
      ))
    }

@delegate:ResourceContentHash(1_806_165_867)
public val Res.string.timeline_requests_title: StringResource by lazy {
      StringResource("string:timeline_requests_title", "timeline_requests_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 366293, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 521669, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 336536, 43),
      ))
    }

@delegate:ResourceContentHash(-46_867_413)
public val Res.string.timeline_save: StringResource by lazy {
      StringResource("string:timeline_save", "timeline_save", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 366700, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 522272, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 336899, 29),
      ))
    }

@delegate:ResourceContentHash(-1_309_975_806)
public val Res.string.timeline_saved: StringResource by lazy {
      StringResource("string:timeline_saved", "timeline_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 366653, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 522197, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 336856, 42),
      ))
    }

@delegate:ResourceContentHash(1_509_626_288)
public val Res.string.timeline_saved_recompute: StringResource by lazy {
      StringResource("string:timeline_saved_recompute", "timeline_saved_recompute", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 366492, 160),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 521956, 240),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 336715, 140),
      ))
    }

@delegate:ResourceContentHash(-2_082_831_819)
public val Res.string.timeline_saved_recompute_start: StringResource by lazy {
      StringResource("string:timeline_saved_recompute_start", "timeline_saved_recompute_start", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 366337, 154),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 521717, 238),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 336580, 134),
      ))
    }

@delegate:ResourceContentHash(-1_444_899_517)
public val Res.string.timeline_show_rejected: StringResource by lazy {
      StringResource("string:timeline_show_rejected", "timeline_show_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 366730, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 522318, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 336929, 58),
      ))
    }

@delegate:ResourceContentHash(1_790_527_173)
public val Res.string.timeline_title_mine: StringResource by lazy {
      StringResource("string:timeline_title_mine", "timeline_title_mine", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 366793, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 522405, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 336988, 43),
      ))
    }

@delegate:ResourceContentHash(2_044_624_449)
public val Res.string.timeline_title_of: StringResource by lazy {
      StringResource("string:timeline_title_of", "timeline_title_of", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 366841, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 522469, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337032, 45),
      ))
    }

@delegate:ResourceContentHash(472_123_244)
public val Res.string.timeline_today: StringResource by lazy {
      StringResource("string:timeline_today", "timeline_today", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 366887, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 522531, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337078, 30),
      ))
    }

@delegate:ResourceContentHash(240_217_385)
public val Res.string.timeline_unpaid_hint: StringResource by lazy {
      StringResource("string:timeline_unpaid_hint", "timeline_unpaid_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 366922, 160),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 522578, 284),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337109, 164),
      ))
    }

@delegate:ResourceContentHash(875_869_011)
public val Res.string.timeline_until: StringResource by lazy {
      StringResource("string:timeline_until", "timeline_until", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367083, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 522863, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337274, 38),
      ))
    }

@delegate:ResourceContentHash(448_032_441)
public val Res.string.timeline_valid_until: StringResource by lazy {
      StringResource("string:timeline_valid_until", "timeline_valid_until", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367118, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 522898, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337313, 52),
      ))
    }

@delegate:ResourceContentHash(-817_235_160)
public val Res.string.tips_amount: StringResource by lazy {
      StringResource("string:tips_amount", "tips_amount", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367239, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 523047, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337446, 39),
      ))
    }

@delegate:ResourceContentHash(1_699_215_993)
public val Res.string.tips_amount_invalid: StringResource by lazy {
      StringResource("string:tips_amount_invalid", "tips_amount_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367167, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 522959, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337366, 79),
      ))
    }

@delegate:ResourceContentHash(453_375_469)
public val Res.string.tips_csv_from: StringResource by lazy {
      StringResource("string:tips_csv_from", "tips_csv_from", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367279, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 523103, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337486, 29),
      ))
    }

@delegate:ResourceContentHash(3_563_342)
public val Res.string.tips_csv_hours: StringResource by lazy {
      StringResource("string:tips_csv_hours", "tips_csv_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367305, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 523129, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337516, 30),
      ))
    }

@delegate:ResourceContentHash(-1_842_359_930)
public val Res.string.tips_csv_role: StringResource by lazy {
      StringResource("string:tips_csv_role", "tips_csv_role", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367340, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 523168, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337547, 29),
      ))
    }

@delegate:ResourceContentHash(470_862_347)
public val Res.string.tips_csv_share: StringResource by lazy {
      StringResource("string:tips_csv_share", "tips_csv_share", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367378, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 523206, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337577, 30),
      ))
    }

@delegate:ResourceContentHash(1_349_960_520)
public val Res.string.tips_csv_to: StringResource by lazy {
      StringResource("string:tips_csv_to", "tips_csv_to", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367413, 23),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 523245, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337608, 23),
      ))
    }

@delegate:ResourceContentHash(-354_751_038)
public val Res.string.tips_delete: StringResource by lazy {
      StringResource("string:tips_delete", "tips_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367494, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 523350, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337677, 35),
      ))
    }

@delegate:ResourceContentHash(830_841_369)
public val Res.string.tips_deleted: StringResource by lazy {
      StringResource("string:tips_deleted", "tips_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367437, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 523273, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337632, 44),
      ))
    }

@delegate:ResourceContentHash(1_987_892_269)
public val Res.string.tips_edit_title: StringResource by lazy {
      StringResource("string:tips_edit_title", "tips_edit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367530, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 523406, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337713, 35),
      ))
    }

@delegate:ResourceContentHash(500_133_261)
public val Res.string.tips_export: StringResource by lazy {
      StringResource("string:tips_export", "tips_export", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367616, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 523516, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337787, 35),
      ))
    }

@delegate:ResourceContentHash(-664_378_233)
public val Res.string.tips_exported: StringResource by lazy {
      StringResource("string:tips_exported", "tips_exported", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367574, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 523462, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337749, 37),
      ))
    }

@delegate:ResourceContentHash(109_612_090)
public val Res.string.tips_from_tablet: StringResource by lazy {
      StringResource("string:tips_from_tablet", "tips_from_tablet", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367656, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 523560, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337823, 52),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString43Resources(map: MutableMap<String, StringResource>) {
  map.put("timeline_intro_mine", Res.string.timeline_intro_mine)
  map.put("timeline_intro_team", Res.string.timeline_intro_team)
  map.put("timeline_kind_contract", Res.string.timeline_kind_contract)
  map.put("timeline_kind_employment", Res.string.timeline_kind_employment)
  map.put("timeline_kind_end", Res.string.timeline_kind_end)
  map.put("timeline_kind_hire", Res.string.timeline_kind_hire)
  map.put("timeline_kind_medical", Res.string.timeline_kind_medical)
  map.put("timeline_kind_not_counted", Res.string.timeline_kind_not_counted)
  map.put("timeline_kind_note", Res.string.timeline_kind_note)
  map.put("timeline_kind_ohs", Res.string.timeline_kind_ohs)
  map.put("timeline_kind_pay", Res.string.timeline_kind_pay)
  map.put("timeline_kind_student", Res.string.timeline_kind_student)
  map.put("timeline_kind_tax_relief", Res.string.timeline_kind_tax_relief)
  map.put("timeline_kind_unpaid", Res.string.timeline_kind_unpaid)
  map.put("timeline_lane_absences", Res.string.timeline_lane_absences)
  map.put("timeline_lane_labour", Res.string.timeline_lane_labour)
  map.put("timeline_lane_overtime", Res.string.timeline_lane_overtime)
  map.put("timeline_lane_remote_events", Res.string.timeline_lane_remote_events)
  map.put("timeline_mine", Res.string.timeline_mine)
  map.put("timeline_moving_to", Res.string.timeline_moving_to)
  map.put("timeline_no_pay_terms", Res.string.timeline_no_pay_terms)
  map.put("timeline_not_available", Res.string.timeline_not_available)
  map.put("timeline_not_counted_hint", Res.string.timeline_not_counted_hint)
  map.put("timeline_open", Res.string.timeline_open)
  map.put("timeline_pay_hourly", Res.string.timeline_pay_hourly)
  map.put("timeline_pay_monthly", Res.string.timeline_pay_monthly)
  map.put("timeline_pay_salary_fte", Res.string.timeline_pay_salary_fte)
  map.put("timeline_problem_contract_after_end", Res.string.timeline_problem_contract_after_end)
  map.put("timeline_problem_contract_before_hire", Res.string.timeline_problem_contract_before_hire)
  map.put("timeline_problem_contract_same_day", Res.string.timeline_problem_contract_same_day)
  map.put("timeline_problem_date_missing", Res.string.timeline_problem_date_missing)
  map.put("timeline_problem_end_before_hire", Res.string.timeline_problem_end_before_hire)
  map.put("timeline_problem_end_before_shift_on", Res.string.timeline_problem_end_before_shift_on)
  map.put("timeline_problem_end_before_shifts", Res.string.timeline_problem_end_before_shifts)
  map.put("timeline_problem_end_before_start", Res.string.timeline_problem_end_before_start)
  map.put("timeline_problem_hire_after_shift_on", Res.string.timeline_problem_hire_after_shift_on)
  map.put("timeline_problem_hire_after_shifts", Res.string.timeline_problem_hire_after_shifts)
  map.put("timeline_problem_hire_has_shifts", Res.string.timeline_problem_hire_has_shifts)
  map.put("timeline_problem_no_pay_terms", Res.string.timeline_problem_no_pay_terms)
  map.put("timeline_problem_note_empty", Res.string.timeline_problem_note_empty)
  map.put("timeline_problem_note_too_long", Res.string.timeline_problem_note_too_long)
  map.put("timeline_problem_outside", Res.string.timeline_problem_outside)
  map.put("timeline_problem_overlap", Res.string.timeline_problem_overlap)
  map.put("timeline_problem_pay_after_end", Res.string.timeline_problem_pay_after_end)
  map.put("timeline_problem_pay_before_hire", Res.string.timeline_problem_pay_before_hire)
  map.put("timeline_problem_pay_same_day", Res.string.timeline_problem_pay_same_day)
  map.put("timeline_problem_required", Res.string.timeline_problem_required)
  map.put("timeline_problem_too_many", Res.string.timeline_problem_too_many)
  map.put("timeline_read_only", Res.string.timeline_read_only)
  map.put("timeline_relief_commuting", Res.string.timeline_relief_commuting)
  map.put("timeline_relief_pit2", Res.string.timeline_relief_pit2)
  map.put("timeline_relief_youth", Res.string.timeline_relief_youth)
  map.put("timeline_remove", Res.string.timeline_remove)
  map.put("timeline_remove_hire_text", Res.string.timeline_remove_hire_text)
  map.put("timeline_remove_text", Res.string.timeline_remove_text)
  map.put("timeline_remove_title", Res.string.timeline_remove_title)
  map.put("timeline_request_approved", Res.string.timeline_request_approved)
  map.put("timeline_request_close", Res.string.timeline_request_close)
  map.put("timeline_request_description", Res.string.timeline_request_description)
  map.put("timeline_request_hours", Res.string.timeline_request_hours)
  map.put("timeline_request_no_drag", Res.string.timeline_request_no_drag)
  map.put("timeline_request_note", Res.string.timeline_request_note)
  map.put("timeline_request_place", Res.string.timeline_request_place)
  map.put("timeline_request_reject_text", Res.string.timeline_request_reject_text)
  map.put("timeline_request_reject_title", Res.string.timeline_request_reject_title)
  map.put("timeline_request_rejected", Res.string.timeline_request_rejected)
  map.put("timeline_request_sent", Res.string.timeline_request_sent)
  map.put("timeline_request_status", Res.string.timeline_request_status)
  map.put("timeline_request_title", Res.string.timeline_request_title)
  map.put("timeline_request_tooltip", Res.string.timeline_request_tooltip)
  map.put("timeline_request_withdraw", Res.string.timeline_request_withdraw)
  map.put("timeline_request_withdraw_text", Res.string.timeline_request_withdraw_text)
  map.put("timeline_request_withdraw_title", Res.string.timeline_request_withdraw_title)
  map.put("timeline_request_withdrawn", Res.string.timeline_request_withdrawn)
  map.put("timeline_requests_hint", Res.string.timeline_requests_hint)
  map.put("timeline_requests_title", Res.string.timeline_requests_title)
  map.put("timeline_save", Res.string.timeline_save)
  map.put("timeline_saved", Res.string.timeline_saved)
  map.put("timeline_saved_recompute", Res.string.timeline_saved_recompute)
  map.put("timeline_saved_recompute_start", Res.string.timeline_saved_recompute_start)
  map.put("timeline_show_rejected", Res.string.timeline_show_rejected)
  map.put("timeline_title_mine", Res.string.timeline_title_mine)
  map.put("timeline_title_of", Res.string.timeline_title_of)
  map.put("timeline_today", Res.string.timeline_today)
  map.put("timeline_unpaid_hint", Res.string.timeline_unpaid_hint)
  map.put("timeline_until", Res.string.timeline_until)
  map.put("timeline_valid_until", Res.string.timeline_valid_until)
  map.put("tips_amount", Res.string.tips_amount)
  map.put("tips_amount_invalid", Res.string.tips_amount_invalid)
  map.put("tips_csv_from", Res.string.tips_csv_from)
  map.put("tips_csv_hours", Res.string.tips_csv_hours)
  map.put("tips_csv_role", Res.string.tips_csv_role)
  map.put("tips_csv_share", Res.string.tips_csv_share)
  map.put("tips_csv_to", Res.string.tips_csv_to)
  map.put("tips_delete", Res.string.tips_delete)
  map.put("tips_deleted", Res.string.tips_deleted)
  map.put("tips_edit_title", Res.string.tips_edit_title)
  map.put("tips_export", Res.string.tips_export)
  map.put("tips_exported", Res.string.tips_exported)
  map.put("tips_from_tablet", Res.string.tips_from_tablet)
}
